export default function getType(dataType: any, fieldName: string) {
  let valueDataType = 'text';
  if (dataType && fieldName) {
    dataType.forEach((data: any) => {
      if (data.fieldName === fieldName) {
        valueDataType = data.schema || data.fieldType;
      }
    });
  }
  return valueDataType;
}
